import { Carousel } from 'antd';
import getConfig from 'next/config';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import withSizes from 'react-sizes';
import { searchBannersBySegment } from '../../actions';
import { isElectron } from '../../electron/tools'
import { isExternal } from '../../lib/CatalogUtils';
import {BREAKPOINT_XS_MOBILE} from "../../constants/CatalogUtils";

const { publicRuntimeConfig } = getConfig();


class CatalogBanners extends Component {

    constructor(props) {
        super(props);
        this.bannerUrls = (isElectron()) ? publicRuntimeConfig.bannerImagesBasePathOffline : publicRuntimeConfig.bannerImagesBasePath
    }

    componentDidMount = () => {
        this.props.searchBannersBySegment();
    }

    renderCarousel = () => {
        const { banners, isMobile } = this.props;
        let rows = [];

        if (Array.isArray(banners.data)) {
            banners.data.forEach(banner => {
                const nameFile = (isMobile) ? banner.bannerMobileImage : banner.bannerImage;
                const urlImg = `${this.bannerUrls}${nameFile}`;
                if (nameFile) {
                    const imgComponent = (
                        <img src={urlImg} style={{ height: '100%', maxWidth: '100%', width: 'auto', margin: '0 auto' }} />
                    );
                    rows.push(
                        <div className="banner-image" key={banner._id}>
                            {banner && banner.bannerLink ?
                                <a href={banner.bannerLink} target={isExternal(banner.bannerLink) ? "_blank" : ""}>
                                    {imgComponent}
                                </a> : imgComponent}
                        </div>
                    );
                }
            });
        }

        return rows;
    }

    render() {
        const { banners } = this.props;

        return (
            <Carousel autoplay >
                {banners && banners.data && this.renderCarousel()}
            </Carousel>
        )
    }
}


const mapStateToProps = ({ auth, banners }) => {
    return {
        auth,
        banners: banners.bannersBySegment,
    };
};

const mapSizesToProps = ({ width }) => ({
    isMobile: width < BREAKPOINT_XS_MOBILE,
})



export default connect(mapStateToProps, { searchBannersBySegment })(withSizes(mapSizesToProps)(CatalogBanners));
